<template>
  <div class="dialog-modal dialogModalNew">
    <div class="dialog-outbox">
      <span class="icon-bgi"></span>
      <div class="dialog-outborder">
        <div class="dialog-container" @click.stop>
          <div class="dialog-header" v-if="title">
            {{ title }}
            <i class="el-icon-close" @click="closeDialog"></i>
            <!-- <span class="icon-bgi"></span> -->
          </div>
          <div class="dialog-content" :style="{ width, height }">
            <i v-if="!title" class="el-icon-close contentClose" @click="closeDialog"></i>
            <span class="icon-bgi"></span>
            <slot name="content"></slot>
          </div>
          <div class="dialog-footer" v-if="!noFooter">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      default: false
    },
    title: {
      type: String
    },
    width: {
      type: String,
      default: "640px"
    },
    height: {
      type: String,
      default: "auto"
    },
    noFooter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {};
  },
  methods: {
    closeDialog () {
      this.$emit("update:visible", false);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

// .dialog-modal {}
.dialogModalNew {
  position: fixed;
  top: -1000px;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;

  // @keyframes fadeIn {
  //   0% {
  //     background: transparent;
  //   }
  //   100% {
  //     background: rgba(0, 0, 0, 0.5);
  //   }
  // }
  // animation: fadeIn 0.5s linear forwards;
  // 外盒子
  .dialog-outbox {
    position: relative;
    // margin-top: -100vh;
    // box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.6);
  }

  // 外边框
  .dialog-outborder {
    position: relative;
    padding: 2px;
    background: linear-gradient(-135deg, transparent 30px, rgba(17, 104, 99, 1) 0);
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .dialog-container {
    // #222D35
    background: linear-gradient(-135deg, transparent 30px, rgba(34, 45, 53, 1) 0);
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // border-left: 1px solid rgba(17, 104, 99, 1);
    // border-bottom: 1px solid rgba(17, 104, 99, 1);
    position: relative;
    // 百叶
    // mask: radial-gradient(
    //   #000 calc(1% * var(--seed)),
    //   transparent calc(1% * var(--seed))
    // );
    mask-size: 60px 60px;
    animation: seed 0.5s;

    .dialog-header {
      position: relative;
      height: 60px;
      padding: 0 20px;
      // border-bottom: 1px solid @borderColor;
      border-bottom: 1px solid rgba(17, 104, 99, 1);
      display: flex;
      // justify-content: center;
      // text-align:center;
      align-items: center;
      background: linear-gradient(-135deg, transparent 30px, rgba(34, 45, 53, 1) 0);
      background-position: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .sc(16px, rgba(163, 199, 215, 1));

      // font-weight: bold;
      i {
        position: absolute;
        top: 7px;
        right: 5px;
        .sc(14px, #16D09A);
        cursor: pointer;
        // &:hover {
        //   color: @hoverColor;
        // }
      }
    }

    .dialog-content {
      padding: 30px 35px;
      overflow: auto;
      max-height: 85vh;
      display: flex;
      flex-direction: column;

      .content_tishi {
        text-align: center;

        .tital {
          display: flex;
          align-items: center;
          justify-content: center;

          .contentdelete {
            // font-size: 20px;
            // font-weight: 600;  
            font-size: 18px;
            color: rgba(255, 62, 62, 1);
            font-weight: bold;
          }

          i {
            font-size: 30px;
            margin-right: 10px;
          }
        }
      }

      .disabledescr {
        // margin-left: 40px;
        display: flex;
        justify-content: center;
        // margin-top: 10px;
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
      }

      .deletfotter {
        margin-top: 50px;

        .button-hollow {
          width: 100px;
          height: 32px;
          margin: 0 6px;
        }

        .button-solid {
          margin: 0 6px;
          width: 100px;
          height: 32px;
        }
      }

      // 关闭删除弹框
      .contentClose {
        position: absolute;
        top: 7px;
        right: 5px;
        .sc(14px, #16D09A);
        cursor: pointer;
      }
    }

    .dialog-footer {
      background: rgba(34, 45, 53, 1);
      height: 60px;
      padding: 0 20px;
      // border-top: 1px solid @borderColor;
      border-top: 1px solid rgba(17, 104, 99, 1);
      display: flex;
      justify-content: flex-end;
      // justify-content: center;
      align-items: center;

      .button {
        font-size: 14px;
        padding: 6px 10px;
        border-radius: 5px;
        // min-width: 100px;
        cursor: pointer;
        margin: 0 6px;
        background-color: #16D09A;
        color: #202D35;
        border: none;
      }

      .button-hollow {
        border-radius: 5px;
        .sc(14px, #666);
        border-color: #ddd;
        .button;

        &:hover {
          background: #f8f9fa;
        }
      }

      .button-solid {
        .button;
      }
    }
  }

  // X 统一背景
  .icon-bgi {
    position: absolute;
    top: 3px;
    right: 3px;
    z-index: -1;
    width: 50px;
    height: 50px;
    display: inline-block;
    // background-color: #05616F;
    background: linear-gradient(224.87deg, rgba(30, 106, 122, 1) 6.62%, rgba(11, 41, 54, 1) 58.55%);
    border-radius: 0px 5px 0px 0px;
  }

  // input
  /deep/.el-input .el-input__inner {
    background: rgba(43, 56, 66, 1);
    // color: rgba(123, 131, 149, 1);
    color: rgba(255, 255, 255, 1);
    // border-color: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(204, 206, 221, 1);
    height: 38px;
    line-height: 38px;
  }

  /deep/.el-input.is-disabled .el-input__inner {
    // border-color: #A3A9B5;
    border: none;
    background: rgba(43, 56, 66, 1);
    color: rgba(242, 242, 242, 0.5);
  }

  // input::-webkit-input-placeholder{
  //   color:red;
  // }
  // input::-moz-placeholder{   /* Mozilla Firefox 19+ */
  //   color:red;
  // }
  // input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
  //   color:red;
  // }
  // input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
  //   color:red;
  // }
  // textarea
  /deep/.el-textarea__inner {
    border-color: #A3A9B5;
    background: rgba(43, 56, 66, 1);
    color: #ffffff;
    padding: 8px;
  }

  /deep/textarea::-webkit-input-placeholder {
    color: rgba(123, 131, 149, 1);
    font-size: 14px;
  }

  /deep/textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: rgba(123, 131, 149, 1);
    font-size: 14px;
  }

  /deep/textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: rgba(123, 131, 149, 1);
    font-size: 14px;
  }

  /deep/textarea:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgba(123, 131, 149, 1);
    font-size: 14px;
  }

  // button
  /deep/.button-solid {
    border: none;
    border-radius: 4px;
    background-color: @primaryTextColor;
    color: #202D35;
  }

  /deep/.button-hollow {
    border: none;
    border-radius: 4px;
    // background-color: #16D09A;
    color: #202D35;
  }

  // table
  // /deep/.el-table thead {}
  /deep/.el-table--border,
  .el-table--group {
    border-color: #A3A9B5;
  }

  /deep/.el-table th,
  .el-table tr {
    background: rgba(43, 56, 66, 1);
    color: #ffffff;
    border-color: #A3A9B5;
  }

  /deep/.el-table__empty-block {
    background: rgba(43, 56, 66, 1);
  }

  /deep/.el-table__empty-text {
    color: #ffffff;
  }
}
</style>
<style lang="less">
.dialogModalNew {
  .dialog-content {
    .el-select {
      width: 100%;
    }

    .el-date-editor.el-input {
      width: 100%;

      .el-input__inner {
        border-radius: 5px;
        padding-left: 15px;
      }
    }

    .el-form-item--small .el-form-item__label {
      font-family: 'Microsoft YaHei';
      color: rgba(255, 255, 255, 1);
      line-height: 20px;
      // padding-bottom: 5px;
    }
  }
}

// 弹窗滑入滑出
.showDialog.dialog-modal {
  @keyframes fadeIn {
    0% {
      // background: transparent;
    }

    100% {
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  animation: fadeIn 0.3s ease-in-out forwards;
}

.showDialog.dialog-modal .dialog-outbox {
  @keyframes popupEnter {
    0% {
      // transform: translateY(-1000px);
      // margin-top: -100vh;
    }

    100% {
      // transform: translateY(0px);
      // margin-top: 25vh;
    }
  }

  // animation: popupEnter 0.3s ease-in-out forwards;
}

// 弹框滑出
.hideDialog.dialog-modal .dialog-outbox {
  @keyframes popupLeave {
    0% {
      // transform: translateY(0px);
      // margin-top: 25vh;
    }

    100% {
      // transform: translateY(-100px);
      // margin-top: -100vh;
    }
  }

  // animation: popupLeave 0.5s ease-in-out forwards;
}

.hideDialog.dialog-modal {
  @keyframes fadeOut {
    0% {
      // background: transparent;
    }

    100% {
      // background: transparent;
      top: -1000px;
      z-index: -1;
    }
  }

  animation: fadeOut 100s ease-in-out forwards;
}</style>

